export default {
  warehouse: {
    WarehouseInfo: 'Warehouse Info',
    WarehouseName: 'Warehouse Name',
    WarehouseCode: 'Warehouse Code',
    WarehouseLinkMan: 'Warehouse Link Man',
    WarehouseTel: 'Warehouse Tel',
    WarehouseAdmin: 'Warehouse Admin',
    ChooseWarehouseAdmin: 'Choose Warehouse Admin',
    ChooseWarehouse: 'Choose Warehouse',
    Address: 'Address',
    Remark: 'Remark',
    IsDefaultWarehouse: 'Is Default Warehouse',
    SetAsDefaultWarehouse: 'Set As Default Warehouse?',
    SetAsDefault: 'Set As Default',
    WarehouseNameCanNotBeEmpty: 'Warehouse Name Can Not Be Empty',
    PleaseEnterCorrectWarehouseName: 'Please Enter Correct Warehouse Name',
    WarehouseAdminCanNotBeEmpty: 'Warehouse Admin Can Not Be Empty',
    PleaseEnterCorrectWarehouseAdmin: 'Please Enter Correct Warehouse Admin',
    AddressCanNotBeEmpty: 'Address Can ot Be Empty',
    AddressMustNotHaveSpaces: 'Address Must Not Have Spaces',
    TelCanNotBeEmpty: 'Tel Can Not Be Empty',
    PleaseEnterCorrectTel: 'Please Enter Correct Tel',
    AddWarehouse: 'Add Warehouse',
    EditWarehouse: 'Edit Warehouse',
    DeptName: 'OrgName',
    Name: 'Name',
    Male: 'Male',
    Female: 'Female'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/ims/warehouse.js